import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RightSidebarBox from './RightSidebarBox';
import { toast } from 'react-toastify';
import { Loader, NoContent } from '../UI';
import axios from '../../axios';

export default function RightSidebar() {
    const authToken = localStorage.getItem('access_token');
    const apiURL = localStorage.getItem('isAdmin') == 0 ? '/user-bookings' : 'bookings';
    const [bookings, setBookings] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchBookings = () => {
        axios.get(apiURL, {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        })
        .then((response) => {
          if (response.data) {
            if (response.status === 200) {
              setBookings(response.data);
            } else {
              toast.warn('No response from server');
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          toast.error('Couldn\'t load bookings');
          setIsLoading(false);
        })
    };
    
    useEffect(() => {
        fetchBookings();
    }, []);

    return (
        <section className='right-sidebar mt-2 ms-lg-2 ms-md-0 ps-lg-4 ps-md-3 pe-md-2 pb-3 custom-scrollbar'>
            <div className='container'>
                <div className='row g-0'>
                    <div className='col-md-12'>
                        <div className='d-flex justify-content-between mb-3'>
                            <h5 className='mb-0'>Recent Bookings</h5>
                            <Link to={'/bookings'} className='link-btn link-font-size'>View All</Link>
                        </div>
                        {
                            !isLoading ? (
                                bookings.length ? (
                                  bookings.slice(0, 6).reverse().map((item)=>{
                                    return(
                                        <RightSidebarBox data={item} key={item.bookingId} />
                                    )
                                  })
                                ) : (
                                  <NoContent />
                                )
                            ) : (
                                <Loader />
                            )
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}
